import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import withStyles from '@mui/styles/withStyles';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import ObservateurIcon from '@mui/icons-material/RemoveRedEye';
import ClientPrioritaireIcon from '@mui/icons-material/WarningTwoTone';
import OsrIcon from '@mui/icons-material/SmartToy';

import Utilisateur from 'components/Shared/Utilisateur';
import Client from 'components/Shared/Client';

import ReclamationStatutIcon from './ReclamationStatutIcon';
import ReclamationPicto from './ReclamationPicto';
import ReclamationCommentairesPicto from './ReclamationCommentairesPicto';
import ReclamationVerificationIcon from './ReclamationVerificationIcon';
import ReclamationGroupeAvatar from './ReclamationGroupeAvatar';

import Datetime from 'components/Shared/Datetime';

import { grey, red } from '@mui/material/colors';

//// FIXME checkout https://mui.com/components/use-media-query/#migrating-from-withwidth
//const withWidth = () => (WrappedComponent) => (props) => <WrappedComponent {...props} width="xs" />;

const styles = theme => ({
    cell: {
        padding: '4px 8px 4px 8px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',

        [theme.breakpoints.only('lg')]: {
            maxWidth: '150px'
        },
        [theme.breakpoints.only('xl')]: {
            maxWidth: '300px'
        }
    },


    noPaddingCell: {
        padding: '0px 0px 0px 0px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',

        [theme.breakpoints.only('lg')]: {
            maxWidth: '150px'
        },
        [theme.breakpoints.only('xl')]: {
            maxWidth: '300px'
        }
    },

    cession: {
        color: grey[500]
    },
    monne2: {
        color: red[500]
    },
    //osrIcon: {
    //    color: grey[600],
    //    fontSize: '1rem',
    //    verticalAlign: 'middle',
    //    marginLeft: '4px'
    //},
    statut0: {
        color: grey[500]
    },
    prioritaire: {
        color: red[500]
    },
    link: theme.style.link
});

const ReclamationRow = ({ classes, reclamation, onClickAffectation, autoriseAffectation, utilisateurGTEntrepot, width }) => {
    let isCession = reclamation.type === 'Cession';
    //let hasOSR = reclamation.osr;
    let hasMonne2 = reclamation.monne2;

    const getCellClassName = (withMonne2 = false) => {
        if (withMonne2 && utilisateurGTEntrepot && hasMonne2) {
            return classNames(classes.cell, classes.monne2);
        }
        if (isCession) {
            return classNames(classes.cell, classes.cession);
        }
        return classes.cell;
    };


    let client = reclamation.client;
    if (!client && reclamation.parent) {
        client = reclamation.parent.client;
    }

    let numeroPiece = reclamation.numeroPiece;
    if (!numeroPiece && reclamation.parent) {
        numeroPiece = reclamation.parent.numeroPiece;
    }

    let numeroPreparation = reclamation.numeroPreparation;
    if (!numeroPreparation && reclamation.parent) {
        numeroPreparation = reclamation.parent.numeroPreparation;
    }

    let depotDepart = reclamation.depotDepart;
    if (!depotDepart && reclamation.parent) {
        depotDepart = reclamation.parent.depotDepart;
    }


    let prioritaire = reclamation.client && (reclamation.client.prioritaire || (reclamation.client.parent && reclamation.client.parent.prioritaire));


    return (
        <TableRow
            hover
            key={reclamation.id}
        >
            <TableCell className={classes.cell}>{reclamation.observateur && <Tooltip title="Observateur"><ObservateurIcon className={classes.statut0} /></Tooltip>} </TableCell>
            <TableCell className={classes.noPaddingCell}><ReclamationPicto picto={reclamation.picto} onClickAffectation={onClickAffectation} autoriseAffectation={autoriseAffectation} /></TableCell>

            <TableCell className={classes.cell}>{prioritaire && <Tooltip title="Client prioritaire"><ClientPrioritaireIcon className={classes.prioritaire} /></Tooltip>} </TableCell>


            <TableCell className={classes.cell}><ReclamationCommentairesPicto commentaires={reclamation.commentaires} /></TableCell>
            <TableCell className={classes.cell}><ReclamationVerificationIcon date={reclamation.dateVerification} depasse={reclamation.dateVerificationDepasse} /></TableCell>
            <TableCell className={classes.cell} align='right'>
                <Link to={`/reclamations/${reclamation.id}`} className={classes.link}>
                    <Typography variant="button" className={isCession ? classes.cession : undefined}>
                        {reclamation.id}
                    </Typography>
                </Link>
            </TableCell>
            <TableCell className={getCellClassName(true)}>
                {numeroPiece}
                {/*{utilisateurGTEntrepot && hasOSR && <Tooltip title="OSR"><OsrIcon className={classes.osrIcon} /></Tooltip>}*/}
            </TableCell>

            <TableCell className={getCellClassName()}>{numeroPreparation}</TableCell>

            <TableCell className={getCellClassName()}>
                { depotDepart && (<span>{`${depotDepart.codeDepot} - ${depotDepart.nom}`}</span>)}
            </TableCell>

            <TableCell className={getCellClassName()}><Datetime datetime={reclamation.dateCreation} shortYear={width !== 'xl'} withTooltip/></TableCell>
            <TableCell className={getCellClassName()}>
                {width === 'lg' || width === 'xl'
                    ? (<Client client={client} format="code-libelle" withTooltip prioritaire={prioritaire} />)
                    : (<Client client={client} format="code" withTooltip prioritaire={prioritaire}/>)
                }
            </TableCell>
            <TableCell className={getCellClassName()}>{reclamation.emetteur ? <Utilisateur utilisateur={reclamation.emetteur} format="court" /> : ''}</TableCell>
            <TableCell className={getCellClassName()}><ReclamationGroupeAvatar groupe={reclamation.groupe.libelle} initiales={reclamation.groupe.initiales} /></TableCell>
            <TableCell className={getCellClassName()}>{reclamation.utilisateur ? <Utilisateur utilisateur={reclamation.utilisateur} format="court" /> : ''}</TableCell>
            <TableCell className={classes.cell}><ReclamationStatutIcon statut={reclamation.statut} /></TableCell>
            <TableCell className={getCellClassName()}>{reclamation.transporteurNom}</TableCell>
            <TableCell className={getCellClassName()} align='right'>{reclamation.departement}</TableCell>
        </TableRow>
    );
};

ReclamationRow.propTypes = {
    classes: PropTypes.object.isRequired,
    reclamation: PropTypes.object.isRequired,
    onClickAffectation: PropTypes.func.isRequired,
    autoriseAffectation: PropTypes.bool.isRequired,
    utilisateurGTEntrepot : PropTypes.bool.isRequired
};

export default withStyles(styles)(ReclamationRow);
